import React, { Component } from "react";
import { Container, Form, Button, Nav, NavItem, NavLink } from "reactstrap";
import "./randomtest.css";
import { library, counter } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sample } from "lodash";
import { faClock } from "@fortawesome/free-solid-svg-icons";
library.add(faClock);

class Randomtest25 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 18
    };
  }

  render() {
    const { count } = this.state;
    return (
      <div>
        <Container className="comming">
          <Form className="boxrandomtest">
            <h1 className="textrandomtest">แบบทดสอบวัดระดับ</h1>
            <h1 className="cdtimer">
              <FontAwesomeIcon icon="clock" /> {count}
            </h1>
            <Form className="Q1">
              <h3 className="textStudy2">
                5.
                “ชื่อเมืองธนบุรีนั้นเห็นจะใช้ชื่อเดิมตั้งแต่เมื่อแรกสร้างปรากฏในพระราชกำหนดเก่า
                ซึ่งตราไว้เมื่อปีกุน จุลศักราช 1069” จุลศักราชที่ระบุไว้นี้
                สามารถเทียบได้กับศักราชข้อใด
              </h3>{" "}
              <br></br>
              <Button className="rdTest1" href="/conclude25_2">
                <h5>ก. มหาศักราช 2817</h5>
              </Button>
              <br></br>
              <Button className="rdTest1" href="/conclude25_2">
                <h5>ข. พุทธศักราช 2205</h5>
              </Button>
              <br></br>
              <Button className="rdTest1" href="/conclude25_2">
                <h5>ค. รัตนโกสินทร์ศก 2324</h5>
              </Button>
              <br></br>
              <Button className="rdTest1" href="/conclude26_3">
                <h5>ง. คริต์ศักราช 2793</h5>
              </Button>
            </Form>

            <Button className="rdTestbt1" href="/conclude25_2">
              <h5>ข้ามข้อนี้</h5>
            </Button>
            <br></br>
            <h3 className="ranknumberB">1</h3>
            <h3 className="ranknumberB1">2</h3>
            <h3 className="ranknumberB1">3</h3>
            <h3 className="ranknumberB1">4</h3>
            <h3 className="ranknumberW1">5</h3>
          </Form>
        </Container>

        <div className="footer text-footer">
          <p>Surasak Noorurk</p>
          <p> Project 5935512072 Computer Engineering</p>
          <NavLink href="https://surasak783023869.wordpress.com/">
            ช่องทางการติดต่อ
          </NavLink>
        </div>
      </div>
    );
  }

  componentDidMount() {
    const { startCount } = this.props;
    this.setState({
      count: startCount
    });
    this.doIntervalChange();
  }

  componentDidMount() {
    this.myInterval = setInterval(() => {
      this.setState(prevState => {
        const newCount = prevState.count - 1;
        if (newCount == -1) {
          clearInterval(this.myInterval);
          this.props.history.push("/conclude25_2");
        }
        return { count: newCount };
      });
    }, 1000);
  }

  componentWillMount() {
    clearInterval(this.myInterval);
  }
}

export default Randomtest25;
